import { render, staticRenderFns } from "./CoverDesignList.vue?vue&type=template&id=0f8faa2a&scoped=true"
import script from "./CoverDesignList.vue?vue&type=script&lang=js"
export * from "./CoverDesignList.vue?vue&type=script&lang=js"
import style0 from "./CoverDesignList.vue?vue&type=style&index=0&id=0f8faa2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8faa2a",
  null
  
)

export default component.exports